import { Box, Paper } from '@mui/material';
import { SidebarProvider } from './Sidebar/context';
import { ClientProvider } from '@/common/application/contexts/ClientContext';

import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import PostLoginHandler from '../PostLoginHandler';

const Layout = () => {
  return (
    <ClientProvider>
      <PostLoginHandler />
      <SidebarProvider>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100vh',
            minHeight: 0,
            backgroundColor: 'white',
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Header />

          <Box
            sx={{
              display: 'flex',
              flex: 1,
              minHeight: 0,
              overflow: 'hidden',
            }}
          >
            <Sidebar />

            <Paper
              component="main"
              sx={{
                flexGrow: 1,
                minHeight: 0,
                px: { xs: 1, sm: 2, md: 4 },
                pb: { xs: 1, sm: 2, md: 4 },
                pt: 0,
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                overscrollBehavior: 'contain',
              }}
            >
              <Outlet />
            </Paper>
          </Box>
        </Box>
      </SidebarProvider>
    </ClientProvider>
  );
};

export default Layout;
